import { getCurrentInstance,inject } from "vue";
import sa from 'sa-sdk-javascript'
import { Base64 } from 'js-base64'


export   function sensors() {

    const internalInstance: any  = getCurrentInstance();
    const http = internalInstance?.appContext.config.globalProperties.$http || {}                   
    var sas: any = sa
    if(process.hasOwnProperty('browser')){
        let saServerUrl = 'https://kilidata.kilimall.com/sa?project=Seller_KSP'
        if(process.env.NODE_ENV == 'production'){
            saServerUrl = 'https://kilidata.kilimall.com/sa?project=Seller_KSP'
        }
        sa.init({
            name: 'sa',
            server_url: saServerUrl,
            heatmap_url: 'http://10.0.40.197:81/js/sensorsdata/heatmap.min.js',
            web_url: saServerUrl,
            heatmap: {
                collect_url: function(){
                    //神策预采集
                    if(!/error/.test(location.href)){
                        return true
                    }
                },
                custom_property:function(  ){
                    return { platform_type:"Wap" ,  client_name: 'NewWap' }
                }
            },
            scrollmap: { // 视区停留 scrollmap 事件
                collect_url: function(){
                    return false
                },
            },
            preset_properties: {
                //是否采集 $latest_utm 最近一次广告系列相关参数，默认值 true。
                latest_utm:false,
                //是否采集 $latest_traffic_source_type 最近一次流量来源类型，默认值 true。
                latest_traffic_source_type:false,
                //是否采集 $latest_search_keyword 最近一次搜索引擎关键字，默认值 true。
                latest_search_keyword:false,
                //是否采集 $latest_referrer 最近一次前向地址，默认值 true。
                latest_referrer:false,
                //是否采集 $latest_referrer_host 最近一次前向地址，1.14.8 以下版本默认是true，1.14.8 及以上版本默认是 false，需要手动设置为 true 开启。
                latest_referrer_host:false,
                //是否采集 $latest_landing_page 最近一次落地页地址，默认值 false。
                latest_landing_page:false,
                //是否采集 $url 页面地址作为公共属性，1.16.5 以下版本默认是 false，1.16.5 及以上版本默认是 true。
                url: true,
                //是否采集 $title 页面标题作为公共属性，1.16.5 以下版本默认是 false，1.16.5 及以上版本默认是 true。
                title: true,
            }    
        })
        sa.registerPage({
            platform_type:"Wap", 
            client_name: 'NewWap'
        });
        // app.use(sa)
        var strTmp = ""   
        strTmp = Base64.encode(
            JSON.stringify(
                Object.assign(
                    {},
                    {
                        anonymousId:sas.store.getDistinctId(),
                        platform_type: 'Wap',
                        client_name: 'NewWap',
                        site_name: 'Kenya'
                    }, 
                    sa.getPresetProperties()
                )
            )
        )
        internalInstance.appContext.config.globalProperties.$saJson = { "sa" : strTmp }
        internalInstance.appContext.config.globalProperties.$sa = sa

        // http.get_sa({ "sa" : strTmp })
        // http.set_sa_obj(sa)
    }
    
}
